/**
 * TanStack Query hooks for stored credentials.
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { apiFetch } from '../client'
import type { CredentialOut } from '../types'

// ── Credentials ────────────────────────────────────────────────────

export function useCredentials() {
  return useQuery({
    queryKey: ['credentials'],
    queryFn: () => apiFetch<CredentialOut[]>('/api/credentials'),
  })
}

export function useUpdateCredential() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ service, key, value }: { service: string; key: string; value: string }) =>
      apiFetch<CredentialOut>(`/api/credentials/${service}/${key}`, {
        method: 'PUT',
        body: JSON.stringify({ value }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['credentials'] }),
  })
}
